import { createObject } from '@/utils/objects'

export const editBookmarkList = (bookmarks) => bookmarks.map((bookmark) => {
  const isEditing = true
  return createObject(bookmark, { isEditing })
})

export const editBookmark = (bookmarkToEdit, bookmarks) => bookmarks.map((bookmark) => {
  const isEditing = bookmarkToEdit.index === bookmark.index
  return createObject(bookmark, { isEditing })
})

export const addBookmark = (bookmarkToAdd, bookmarksArray) => {
  const bookmarks = bookmarksArray.map((bookmark) => createObject(bookmark, { isEditing: false }))

  bookmarks.push(bookmarkToAdd)

  return bookmarks
}

export const deleteBookmark = (bookmarkIndexToRemove, bookmarksArray) => {
  const bookmarks = bookmarksArray.map((bookmark) => createObject(bookmark, { isEditing: false }))

  bookmarks.splice(bookmarkIndexToRemove, 1)

  return bookmarks
}

export const pushBookmark = (bookmarks) => {
  const newBookmark = {
    associationId: null,
    index: bookmarks.length,
    isEditing: true,
    reportPath: null,
    baseReportName: null,
    routeName: null,
    subId: null,
  }

  bookmarks.push(newBookmark)

  return bookmarks
}
